export default class Surnames {
  id: string;
  name: string;
  namegujarati: string;
  subcastname: string;
  subcastgujaratiname: string;

  constructor(data: Partial<Surnames> = {}) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.namegujarati = data.namegujarati || "";
    this.subcastname = data.subcastname || "";
    this.subcastgujaratiname = data.subcastgujaratiname || "";
  }
}
